/**
 * Projection filter operation types
 */
export enum ProjectionFilterOperationEnum {
	/**
	 * Include items where field equals value
	 */
	EQUALS = 'equals',

	/**
	 * Include items where field does not equal value
	 */
	NOT_EQUALS = 'notEquals',

	/**
	 * Include items where field contains value (string fields)
	 */
	CONTAINS = 'contains',

	/**
	 * Include items where field is in array of values
	 */
	IN = 'in',

	/**
	 * Include items where field is not in array of values
	 */
	NOT_IN = 'notIn',

	/**
	 * Include items where field is greater than value
	 */
	GREATER_THAN = 'gt',

	/**
	 * Include items where field is less than value
	 */
	LESS_THAN = 'lt',

	/**
	 * Include items where field exists (is not null/undefined)
	 */
	EXISTS = 'exists',
}
